import React from 'react';

interface PortfolioBriefButtonProps {
  onClick: () => void;
  isLoading: boolean;
}

/** "Market Brief" — opens the AI brief for the portfolio. Styled by `.brief-btn`. */
const PortfolioBriefButton: React.FC<PortfolioBriefButtonProps> = ({ onClick, isLoading }) => (
  <button type="button" className="brief-btn" onClick={onClick} disabled={isLoading} title="Market & Portfolio Brief">
    <svg viewBox="0 0 16 16" aria-hidden="true" className={isLoading ? 'is-spin' : ''}>
      {isLoading ? <path d="M8 2a6 6 0 1 1-6 6" /> : <path d="M3 4h10M3 8h10M3 12h6" />}
    </svg>
    <span>{isLoading ? 'Writing brief…' : 'Market brief'}</span>
  </button>
);

export default PortfolioBriefButton;
